export default __webpack_public_path__ + "media/3.9807a.png";